import React, {useEffect, useRef, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {useNavigate} from 'react-router-dom'
import {createServiceRattachement, editServiceRattachement} from '../../../../components/requests'

const uploadDir = `${(process.env.REACT_APP_API_URL ?? '')}/uploads/serviceRattachement`

const validate = (values) => {
  const errors: { libelle?: string, image?: string } = {}

  if (!values.libelle) errors.libelle = 'Le libellé est requis'
  if (!values.image) errors.image = 'L\'image est requis'

  return errors
}

const ServiceRattachementForm = ({id, data}) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [file, setFile] = useState<any | null>(null)
  const [photoPreview, setPhotoPreview] = useState<string | null>(data?.image ? `${uploadDir}/${(data?.image ?? '')}` : null)
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  // Charger les données pour la modification
  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('libelle', data.libelle)
      formik.setFieldValue('image', data.image)
    }
  }, [data])

  // Méthode pour ouvrir la fenêtre d'ajout d'image
  const handleButtonClick = () => {
    if (fileInputRef.current) fileInputRef.current.click()
  }

  // Méthode de controle des données de l'image
  const handleChangeImage = (event) => {
    const file = event.target.files ? event.target.files[0] : null
    if (file) {
      // Image à envoyer vers le backend
      setFile(file)
      // Immage à afficher avant la soumission du formulaire
      setPhotoPreview(URL.createObjectURL(file))
      formik.setFieldValue('image', file.name)
    }
  }

  const formik = useFormik({
    initialValues: {
      libelle: data?.libelle ?? '',
      image: data?.image ?? ''
    },
    validate,
    onSubmit: (values) => {
      setIsLoading(true)
      let action = (data === null)
        ? createServiceRattachement(values.libelle, file)
        : editServiceRattachement(id, values.libelle, file)
      action
        .then((response) => {
          if (response?.data !== undefined && response?.status === 200) {
            navigate('/service-rattachement/liste')
          }
        })
        .catch(() => console.log('erreur'))
        .finally(() => setIsLoading(false))
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Libellé</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'libelle'}
                    inputPlaceholder={'Libellé'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Image</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  {/* Formulaire pour l'image - Début */}
                  <div className='input-group'>
                    <input
                      ref={fileInputRef}
                      type='file'
                      name='image'
                      accept='.png, .jpg, .jpeg'
                      style={{display: 'none'}}
                      onChange={handleChangeImage}
                    />
                    <a
                      className='btn btn-secondary'
                      onClick={handleButtonClick}
                      style={{borderRadius: '4px 0 0 4px'}}
                    >
                      Choisir une image
                    </a>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Insérer votre fichier ici'
                      value={file?.name ?? data?.image ?? ''}
                      readOnly
                    />
                  </div>
                  {(formik.errors.image && typeof formik.errors.image === 'string') && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.image}</div>
                    </div>
                  )}
                  {/* Formulaire pour l'image - Fin */}

                  {/* Prévisualisation de l'image - Début */}
                  {photoPreview && (
                    <div className='pdp-image d-flex justify-content-lg-center mt-10'>
                      <img
                        src={photoPreview || undefined}
                        alt='Image service rattachement'
                        style={{
                          width: '150px',
                          height: '150px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          marginTop: '10px',
                          boxShadow: '0 2px 6px #666',
                        }}
                      />
                    </div>
                  )}
                  {/* Prévisualisation de l'image - Fin */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => navigate(`/service-rattachement/liste`)}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {ServiceRattachementForm}
